import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fabric:null,
  loadingFab:false,
  item:0,
};


const fabricSlice = createSlice({
    name: "fabric",
    initialState,
    reducers: {
        getFabricFile(state, action){
          state.loadingFab = false;
          state.fabric = action.payload;
          state.loadingFab = true;
          // state.item = state.fabric.find((i)=> i.fabricName === state.item)
      },
      itemFile(state, action){
        state.item = state.fabric.find((i)=> i.fabricName === action.payload)
      }
    },
  });

  export default fabricSlice.reducer;
  export const {
    getFabricFile,itemFile,loadingFab
  } = fabricSlice.actions;